import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import HelperText from './HelperText'

import { getProps } from './utils'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  prependText: {
    marginRight: theme.spacing(1),
    flexGrow: 0,
    color: '#999'
  },
  textField: {
    flexGrow: 1,
  },
}))

const Text = (props) => {
  const classes = useStyles()
  const {
    field: {
      name,
      value,
      onChange,
      onBlur
    },
    disabled,
    error,
    touched,
    item,
    onSubmit,
  } = getProps(props)
  const inputProps = item.inputProps || {}

  const onKeyPress = useCallback((e) => {
    if (e.key === "Enter" && item.enterSubmit && onSubmit) onSubmit()
  }, [
    onSubmit,
  ])

  const textField = (
    <>
      <TextField
        fullWidth
        id={ name }
        name={ name }
        label={ item.title || item.id }
        helperText={ item.helperText }
        value={ typeof(value) === 'undefined' ? '' : value }
        disabled={ disabled }
        onChange={ onChange }
        onKeyPress={ onKeyPress }
        onBlur={ onBlur }
        { ...inputProps }
      />
      {
        error && touched && (
          <HelperText
            helperText={ error }
            error
            touched={ touched }
          />
        )
      }
    </>
  )

  if(!item.prependText) return textField

  return (
    <div className={ classes.container }>
      <div className={ classes.prependText }>
        { item.prependText }
      </div>
      <div className={ classes.textField }>
        { textField }
      </div>
    </div>
  )
}

export default Text